module.exports = __webpack_public_path__ + "static/wave-sun-36a594cf2bd5b687277f23083fa31799.png";